import { db, ProjectEntity } from "@/shared/lib/db"
import { BaseLocalRepository } from "@/shared/services/repository/BaseRepository"
import { ProjectRepository } from "./project.repository"

class ProjectLocalRepository extends BaseLocalRepository<ProjectEntity> implements ProjectRepository {
    constructor() {
        super(db.project, 'project')
    }

    get(id: string): Promise<ProjectEntity | undefined> {
        return this.table.get(id as any)
    }
    getAll(filter?: ((item: ProjectEntity) => boolean) | undefined): Promise<ProjectEntity[]> {
            if (filter) {
            return this.table.filter(filter).toArray()
        }
        return this.table.toArray()
    }
    save(item: ProjectEntity, sync?: boolean): Promise<void> {
        return super.save(item, sync)
    }
    delete(id: string, sync?: boolean): Promise<void> {
        return super.delete(id, sync)
    }
}

export const projectLocalRepository = new ProjectLocalRepository()